const TMP_URL = `${process.env.REACT_APP_TMP_ORIGIN_URL}/admin/country-map`

const TmpCountryApiUrls = {
    GET: `${TMP_URL}/get`,
    DELETE: `${TMP_URL}/delete`
}

export default TmpCountryApiUrls